import type {
  Election,
  Province,
  District,
  Constituency,
  ElectionResult,
  VoterStatistics,
  Party,
  MapData,
} from './types';

const API_BASE = '/api';

export async function fetchElections(): Promise<Election[]> {
  const response = await fetch(`${API_BASE}/elections`);
  if (!response.ok) throw new Error('Failed to fetch elections');
  return response.json();
}

export async function fetchProvinces(): Promise<Province[]> {
  const response = await fetch(`${API_BASE}/provinces`);
  if (!response.ok) throw new Error('Failed to fetch provinces');
  return response.json();
}

export async function fetchDistricts(provinceId?: string): Promise<District[]> {
  const url = provinceId 
    ? `${API_BASE}/districts?provinceId=${provinceId}`
    : `${API_BASE}/districts`;
  const response = await fetch(url);
  if (!response.ok) throw new Error('Failed to fetch districts');
  return response.json();
}

export async function fetchConstituencies(params?: {
  provinceId?: string;
  districtId?: string;
  search?: string;
}): Promise<Constituency[]> {
  const searchParams = new URLSearchParams();
  if (params?.provinceId) searchParams.set('provinceId', params.provinceId);
  if (params?.districtId) searchParams.set('districtId', params.districtId);
  if (params?.search) searchParams.set('search', params.search);
  
  const url = `${API_BASE}/constituencies?${searchParams.toString()}`;
  const response = await fetch(url);
  if (!response.ok) throw new Error('Failed to fetch constituencies');
  return response.json();
}

export async function fetchElectionResults(
  constituencyId: string,
  electionId?: string
): Promise<ElectionResult[]> {
  const url = electionId
    ? `${API_BASE}/results?constituencyId=${constituencyId}&electionId=${electionId}`
    : `${API_BASE}/results?constituencyId=${constituencyId}`;
  const response = await fetch(url);
  if (!response.ok) throw new Error('Failed to fetch election results');
  return response.json();
}

export async function fetchVoterStatistics(
  constituencyId: string,
  electionId?: string
): Promise<VoterStatistics[]> {
  const url = electionId
    ? `${API_BASE}/statistics?constituencyId=${constituencyId}&electionId=${electionId}`
    : `${API_BASE}/statistics?constituencyId=${constituencyId}`;
  const response = await fetch(url);
  if (!response.ok) throw new Error('Failed to fetch voter statistics');
  return response.json();
}

export async function fetchParties(): Promise<Party[]> {
  const response = await fetch(`${API_BASE}/parties`);
  if (!response.ok) throw new Error('Failed to fetch parties');
  return response.json();
}

export async function fetchMapData(): Promise<MapData> {
  const response = await fetch('/geojson/districts.json');
  if (!response.ok) throw new Error('Failed to fetch map data');
  return response.json();
}
